(() => {
  'use strict';

  const root = document.querySelector('[data-trm-guide-hub]');
  if (!root) return;

  const vehicleLabel = root.querySelector('[data-trm-guide-vehicle]');
  const garageButton = root.querySelector('[data-trm-guide-garage]');
  const storageKey = 'trmSelectedVehicleV1';

  const render = () => {
    try {
      const vehicle = JSON.parse(localStorage.getItem(storageKey) || 'null');
      vehicleLabel.textContent = vehicle?.label || 'Choose your truck';
    } catch (error) {
      vehicleLabel.textContent = 'Choose your truck';
    }
  };

  garageButton?.addEventListener('click', () => {
    window.dispatchEvent(new CustomEvent('trm:garage-open', {
      detail: { trigger: garageButton }
    }));
  });

  window.addEventListener('trm:vehicle-changed', render);
  window.addEventListener('trm:vehicle-cleared', render);
  render();
})();
